import { Theme, FinalizedColorPalette } from '@cvent/carina/types/theme';
import merge from 'deepmerge';
import defaultFormula from './defaultFormula';
import commonOverrides from './commonOverrides';
import { FinalizedWaxColorPalette } from './types';

/** Experimental WAX formula */
export default function lightRailsFormula(palette: FinalizedColorPalette, overrides: FinalizedWaxColorPalette): Theme {
  const defaultTheme = defaultFormula(palette);
  const common = commonOverrides(defaultTheme, overrides.default);
  return merge(common, {
    font: {
      color: {
        brand: {
          base: overrides.default.secondary.seedColor
        }
      }
    }
  });
}
